<template>
  <div></div>
</template>

<script>
window.location.replace('https://web.aerologixmaps.com/404')

</script>


